import { typeCreatorV2 } from '../../utils/common';

//  [REDUCER][TYPE]
export const SET_ADMIN_DASHBOARD_DATA: string = typeCreatorV2(
  'AdminDashboardReducer',
  'SetAdminDashboardData'
);

export const SET_TRADER_DASHBOARD_DATA: string = typeCreatorV2(
  'AdminDashboardReducer',
  'SetTraderDashboardData'
);
